import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalText,
  AcceptButton,
  CancelButton,
} from "./DeleteConfirmModal.styled";

const DeleteConfirmModal = ({ onConfirm, onCancel, show, isDeletingAll }) => {
  if (!show) {
    return null;
  }

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Potwierdzenie usunięcia</ModalHeader>
        <ModalText>
          {isDeletingAll ? (
            <>
              <strong>Uwaga!</strong> Czy na pewno chcesz usunąć <strong>całą historię rozmów</strong>?
            </>
          ) : (
            <>
              Czy na pewno chcesz usunąć zaznaczone wpisy z historii?
            </>
          )}
        </ModalText>
        <ModalText style={{ color: "#ff6b35", fontWeight: "600" }}>
          Ta operacja jest <strong>bezpowrotna</strong> i nie można jej cofnąć.
        </ModalText>
        <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
          <CancelButton onClick={onCancel}>
            Anuluj
          </CancelButton>
          <AcceptButton onClick={onConfirm}>
            Usuń
          </AcceptButton>
        </div>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DeleteConfirmModal;
